import React from 'react';
import { getLabel } from '../../../data/labels';
import { AgendaStreamingContext } from '../../../common/AgendaStreamingContextProvider';

function AgendaStreamingSelection(props) {
	const agendaStreamingContext = React.useContext(AgendaStreamingContext)
    
	function handleClick() {
		agendaStreamingContext.setShowAgendaStreaming(true);
	}

	const selected = props.selected ? ' icona-selezionata' : '';
    const icoAgendaStr = 'icoAgendaStr';
    
	return (
      <div className={"icona-slider-sport icona-streaming " + selected} style={{order: props.order}} onClick={handleClick}>
		    <figure className="sport-icona-live">
                {props.counter != null &&
    			    <span className="contatore-live-icone">{props.counter}</span>
                }
			    <div className={`img-fluid ico-sport ${icoAgendaStr}`}>
                </div>
			    <span>{getLabel('live_page.streams_schedule.live_feed')}</span>
		    </figure>
	    </div>
    );
}

export default AgendaStreamingSelection;